var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22 3.5H2C1.1715 3.5 0.5 4.1715 0.5 5V19C0.5 19.8285 1.1715 20.5 2 20.5H22C22.8285 20.5 23.5 19.8285 23.5 19V5C23.5 4.1715 22.8285 3.5 22 3.5Z",
  fill: "#007AC6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.2665 12.2145H6.4315L5.849 10.786L5.2665 12.2145ZM21.5 9.5H18.5155L17.7875 10.2855L17.132 9.5H10.799L10.2165 10.7855L9.634 9.5H7.086V10.0715L6.795 9.5H4.611L2.5 14.5H5.048L5.339 13.7145H6.067L6.358 14.5H9.197V13.9285L9.4155 14.5H10.8715L11.09 13.857V14.5H16.914L17.642 13.7145L18.297 14.5H21.2815L19.389 12L21.5 9.5ZM12.6915 13.7855H11.8905V11L10.653 13.7855H9.925L8.6875 11V13.7855H7.013L6.722 13H4.975L4.684 13.7855H3.7375L5.266 10.214H6.5035L7.8865 13.571V10.214H9.2695L10.3615 12.6425L11.3805 10.214H12.7635V13.7855H12.6915ZM19.8985 13.7855H18.8065L17.86 12.571L16.768 13.7855H13.492V10.214H16.8405L17.8595 11.357L18.9515 10.214H19.9705L18.3695 12L19.8985 13.7855ZM14.293 10.9285V11.5715H16.113V12.286H14.293V13H16.3315L17.278 11.9285L16.4045 10.9285H14.293Z",
  fill: "white"
});

function SvgAmex(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.c3d4b5f8da6749b96186901af2d617c0.svg";
export { ForwardRef as ReactComponent };